import React from "react";
import Icon from "./Icon";

const CommentSvg = ({ className = "h-6 w-6" }) => (
  <Icon name="comment" className={className} strokeWidth={1.5} />
);

export default CommentSvg;
